import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./components/Auth/Login";
import Main from "./components/Layout/Main";
import MainSuperAdmin from "./components/Layout/MainSuperAdmin";
import Dashboard from "./components/Pages/Common/Dashboard";

const PrivateRoute = () => {
  const loginToken = localStorage.getItem("loginToken");

  if (!loginToken) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

const AppRoutes = () => {
  const { isSuperAdmin } = useSelector((state) => state.user.userInfo);
  const { isImpersonating, companyID } = useSelector((state) => state.app);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<PrivateRoute />}>
        {isImpersonating ? (
          <Route
            element={
              <Main>
                <p style={{ color: "red", textAlign: "center", fontWeight: "bold" }}>
                  You are impersonating Company ID: {companyID}
                </p>
              </Main>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>
        ) : isSuperAdmin ? (
          <Route element={<MainSuperAdmin />}>
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>
        ) : (
          <Route element={<Main />}>
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>
        )}
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;